import React from 'react';

import { Text } from '../../Text';
import { Button } from '../../Button';
import { CrossIcon } from '../../../icons';
import { IconMap } from '../constants';
import { AlertProps } from './types';
import { FlexRow } from '../../Flex/FlexRow';
import { FlexCol } from '../../Flex/FlexCol';
import { assignCssVars, buildClassnames } from '../../../utils';

import alertStyles from '../Alerts.module.scss';
import styles from './Alert.module.scss';

export const Alert = ({
  size = 'base',
  variant = 'default',
  colours: passedColours,
  rightActions,
  rightActionsSlot,
  title,
  titleSlot,
  messageSlot,
  message,
  children,
  iconSlot,
  onClickClose,
  className,
  ...divProps
}: AlertProps) => {
  const DefaultIcon = IconMap[variant];

  const isXsSize = size === 'xs';

  return (
    <FlexRow
      justifyContent="space-between"
      className={buildClassnames([
        styles.alertContainer,
        styles[`${size}-size`],
        alertStyles[`${variant}-alert-variant`],
        className,
      ])}
      flexWrap="nowrap"
      {...divProps}
    >
      <FlexRow
        alignItems={isXsSize ? 'center' : 'flex-start'}
        flexWrap="nowrap"
        className={styles.iconTextContainer}
      >
        <FlexRow
          style={assignCssVars({ iconColor: passedColours?.primary })}
          className={alertStyles.icon}
          alignItems="flex-start"
        >
          {iconSlot || <DefaultIcon role="presentation" />}
        </FlexRow>

        {children || (
          <FlexCol gap={isXsSize ? 'xs' : 'sm'}>
            {titleSlot || (
              <Text variant="bodyBold" style={size === 'base' ? { lineHeight: '24px' } : {}}>
                {title}
              </Text>
            )}
            {messageSlot || <Text variant="body">{message}</Text>}
          </FlexCol>
        )}
      </FlexRow>

      <FlexRow justifyContent="flex-end" flexWrap="nowrap" className={styles.rightActionsContainer}>
        {rightActionsSlot}

        {rightActions && (
          <FlexCol justifyContent="center" className={styles.rightActions}>
            {rightActions.map(({ label, ...actionProps }) => (
              <Button key={label} type="button" size="sm" {...actionProps}>
                {label}
              </Button>
            ))}
          </FlexCol>
        )}

        {onClickClose && (
          <FlexCol className={styles.closeContainer}>
            <Button
              variant="flat"
              iconSlot={<CrossIcon />}
              onClick={onClickClose}
              aria-label="Close"
              size="sm"
            />
          </FlexCol>
        )}
      </FlexRow>
    </FlexRow>
  );
};
